import { getListItemByPlanId } from './list';
// import { idb } from './map/storage';
import { highlightPlanId } from './map/tools';
import { toNumber } from './table';
import { createSlider, createNavigationTo } from './util';

const typeFromString = s => isNaN(toNumber(s)) ? 'alpha' : 'num';

const by = (type, i, order) => {
  const v = s => (type === 'num') ? toNumber(s) : s;
  const c = r => v(r.cells[i].innerHTML);
  const d = (a, b) => (a > b) ? 1 : -1;
  // return (r1, r2) => (order === 'asc' ? 1 : -1) * (c(r1) - c(r2)); // only num
  return (r1, r2) => (order === 'asc' ? 1 : -1) * d(c(r1), c(r2));
};

const addReorderFunctionality = t => {
  // t.tHeader.cells
  t.querySelectorAll('th').forEach((th, i) => {
    th.title = 'Trykk for å sortere';
    th.onclick = () => {
      const ordering = th.classList.contains('asc') ? 'desc' : 'asc';
      // Remove classes asc and desc from other headers:
      t.querySelectorAll('th').forEach(h => h.classList.remove('asc', 'desc'));
      // Reorder:
      const tb = t.tBodies[0];
      const tr1 = tb.rows[0];
      const type = (i === 0) ? 'alpha' : typeFromString(tr1.cells[i].innerHTML);
      // console.log(tr1.cells[i].innerHTML, i, type, ordering);
      // console.log(Array.from(tb.querySelectorAll('tr:not(.summary)'))
      //   .sort(by(type, i, ordering)).map(r => r.cells[i].innerHTML));
      Array.from(tb.querySelectorAll('tr:not(.summary)'))
        .sort(by(type, i, ordering)).forEach(r => tb.appendChild(r));
      // Add class asc/desc, to show arrow and be able to decide on next click:
      th.classList.add(ordering);
    };
  });
};

const createMirrorSlider = planId => {
  const slider = createSlider();
  slider.name = planId;
  const originalSlider = getListItemByPlanId(planId).querySelector('.slider');
  slider.value = originalSlider.value;
  slider.oninput = () => {
    originalSlider.value = slider.value;
    // setPlanIdOpacity(layer, planId, slider.value);
    originalSlider.dispatchEvent(new Event('input'));
    results.querySelectorAll(`.slider[name="${planId}"`).forEach(s =>
      s.value = slider.value
    );
  };
  // slider.onchange = () => idb.updateLayer(layer);
  slider.onchange = () => originalSlider.dispatchEvent(new Event('change'));
  return slider;
};

export const addInteractionToTable = (t, withButtons) => {
  // console.log('addInteractionToTable', t.id);
  // console.log(t.tBodies[0].rows); // HTMLCollection
  addReorderFunctionality(t);
  // Highlight on mouseover:
  t.querySelectorAll('tbody > tr:not(.summary) > td:first-child').forEach(c => {
    const planId = c.innerHTML;
    // console.log(planId);
    if (withButtons) {
      const div = document.createElement('div');
      div.appendChild(createNavigationTo(planId));
      // c.parentNode.querySelector('td:last-child').appendChild(div);
      // div.appendChild(createMirrorSlider(planId));
      c.parentNode.appendChild(div);
    }
    c.parentNode.onmouseenter = () => {
      // console.log('enter', planId);
      // Highlight table rows belonging to same planId:
      t.querySelectorAll('tbody > tr:not(.summary)').forEach(tr => {
        const td = tr.firstElementChild;
        if (td.innerHTML === planId) tr.classList.add('highlight');
      });
      // Highlight features on map belonging to same planId:
      highlightPlanId(planId, true);
      // Show navigation button and slider to interact with feature on map:
      // done by using tr:hover i css
    };
    c.parentNode.onmouseleave = () => {
      // console.log('leave', planId);
      // Lowlight table rows belonging to same planId:
      t.querySelectorAll('tbody > tr:not(.summary)').forEach(tr => {
        const td = tr.firstElementChild;
        if (td.innerHTML === planId) tr.classList.remove('highlight');
      });
      // Lowlight features on map belonging to same planId:
      highlightPlanId(planId, false);
      // Hide navigation button and slider to interact with feature on map:
      // done by using tr:hover i css
    };
  });
};
